module.exports = __webpack_public_path__ + "img/image8.96566016.png";